<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-circus" [fullScreen] = "true"></ngx-spinner>
<div class="container-fluid">
  <app-pagetitle title="Product Size Setup" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <!-- <h4 class="card-title">Purchase Order List</h4> -->


          
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
              <button type="button" class="btn btn-primary tblebtn w-md" (click)="resetAndopenModal(addmstModal)"><i
                  class="mdi mdi-plus"></i>Add New</button>

              <!-- <div class="dataTables_length" id="tickets-table_length"><label
                  class="d-inline-flex align-items-center">Show
                  <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                    [(ngModel)]="service.pageSize"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                  </select> entries</label></div> -->
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div class="row navbar">
                <div class="col-6 d-flex justify-content-left">
                </div>
                <div class="col-6 d-flex justify-content-end">
                  <div class="row">
                    <div>
                      <input class="form-control" [(ngModel)]="searchString" placeholder="Search" id="searchString"
                        name="searchString" (keyup)="searchExistingRecords($event)" />
                    </div>
                    <!-- <div>
                            <button class="btn btn-primary" (click)="searchDBRecords()"><i
                                    class="ti-search m-r-5 m-l-5"></i></button>
                        </div> -->
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <table #table class="table table-hover m-t-20 table-bordered">
                <thead class="bg-info text-white">
                  <tr class="">
                    <th>Code</th>
                    <th>Name</th>
                    <th>Created By</th>
                    <th>Active</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody class="border border-info">
                  <tr *ngFor="let item of work">

                    <td>{{item.SizeCode}}</td>
                    <td>{{item.PrdSize}}</td>
                    <td>{{item.UserName}}</td>
                    <td>{{item.IsActiveF}}</td>
                    <td>
                      <!-- <button type="button" class="btn btn-outline-info tblebtn"
                                (click)="downloadOriginalExcel(item,1)">
                                <i class="ti-download "></i> Download Excel File</button> 
                                &nbsp; <br/>-->
                      <a href="javascript:void(0);" (click)="editRecord(item.psid,addmstModal)" class="text-primary"
                        ngbTooltip="Edit"><i class="mdi mdi-file-document-edit-outline font-size-22 "></i></a>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ngb-pagination [collectionSize]="pager.totalItems " [pageSize]="pager.pageSize "
              [(page)]="pager.currentPage " [maxSize]="10 " [rotate]="true " (pageChange)="setPage(pager.currentPage) "
              [boundaryLinks]="true ">
            </ngb-pagination>

          </div>
        </div>
      </div>
    </div>
  </div>



    <!-- Modal -->
    <ng-template #addmstModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title mt-0">Size Setup</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">

        <ul class="nav nav-tabs">
          <li class="active"><a data-toggle="tab" href="#home">Home</a></li>
          <li><a data-toggle="tab" href="#menu1">Menu 1</a></li>
        </ul>
        <div class="tab-content">
          <div id="home" class="tab-pane fade in active">
            <h3>HOME</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          </div>
          <div id="menu1" class="tab-pane fade">
            <h3>Menu 1</h3>
            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </div>
        </div>
      
            
        <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform">
          <div class="row">
            <div class="col-lg-12">
              <div class="card o">
                <div class="card-body o">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <label for="GROUP_NAME">Item group Name</label>
                        <input class="form-control" formControlName="GROUP_NAME" id="GROUP_NAME"
                          [ngClass]="{'is-invalid': submit && form.GROUP_NAME.errors}">
                        <div *ngIf="submit && form.GROUP_NAME.errors" class="invalid-feedback">
                          Please provide Group Name
                        </div>
                      </div>
                    </div>
                   
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="GR_CODE">Group Code</label>
                        <input class="form-control" readonly disabled formControlName="GR_CODE" id="GR_CODE"
                          [ngClass]="{'is-invalid': submit && form.GR_CODE.errors}">
                        <div *ngIf="submit && form.GR_CODE.errors" class="invalid-feedback">
                          Please provide Group Code
                        </div>
                      </div>
                    </div>
                  </div>
                <div class="row">

                
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="SGR_CODE">Super Group </label>
                      <ng-select  formControlName="SGR_CODE" name="SGR_CODE" id="SGR_CODE" [items]="SGR_CODEList"
                        bindLabel="Name" bindValue="Code" [(ngModel)]="SGR_CODE"></ng-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="ImGstCode">Tax Category</label>
                      <ng-select  formControlName="ImGstCode" name="ImGstCode" id="ImGstCode" [items]="ImGstCodeList"
                        bindLabel="Name" bindValue="Code" [(ngModel)]="ImGstCode"></ng-select>
                      <!-- <div class="invalidValidate" *ngIf="checkBrand()">
                        Please provide Brand
                      </div> -->
                    </div>
                  </div>
                  
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="GSTHsnCode">HSN/SAC Code for GST</label>
                      <input class="form-control" formControlName="GSTHsnCode" id="GSTHsnCode"
                        [ngClass]="{'is-invalid': submit && form.GSTHsnCode.errors}">
                      <!-- <div *ngIf="submit && form.GSTHsnCode.errors" class="invalid-feedback">
                        Please provide HSN/SAC Code for GST
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="row">
                </div>
                <div class="row">
                  <div class="col-md-7">
                  </div>
                  <div class="col-md-5">
                    <button type="submit" class="btn btn-primary tblebtn w-md">
                      Save
                    </button>&nbsp;
                    <button type="button" (click)="modal.dismiss('Cross click')" class="btn btn-secondary tblebtn w-md">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </ng-template>
  </div>